// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__HKkUZ","truncatedText":"styles_truncatedText__Yy2oP","fullText":"styles_fullText__3GUWQ","textContainer":"styles_textContainer__6gA0b"};